import React from "react";

const DropdownMenu = ({ label = "Dropdown", btnClass="btn-green", options = [], onOptionClick, isDisabled }: any) => {
  return (
    <div className="dropdown">
      <button
        className={`${btnClass} dropdown-toggle`}
        // href="#"
        role="button"
        id="dropdownMenuLink"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        disabled={isDisabled}
      >
        {label}<i className="fa-solid fa-caret-down ms-2"></i>
      </button>

      <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
        {options?.map((option: any, index: number) => (
          <li key={index}>
            <a
              className="dropdown-item"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                onOptionClick(option, index);
              }}
            >
              {option.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DropdownMenu;
